import { render } from "./a-footer-safearea.vue?vue&type=template&id=b0df63fc"
const script = {}

import "./a-footer-safearea.vue?vue&type=style&index=0&id=b0df63fc&lang=sass"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/projects-manager/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__